import { Provider, StrategyProviders } from "./strategies";

export interface VADConfigDraft {
  enabled: boolean;
  confidence: number;
  start_secs: number;
  stop_secs: number;
  min_volume: number;
}

export interface ProviderSettingsDraft {
  provider: Provider | null;
  settings: Record<string, any>;
}

export interface RealtimeConfigDraft {
  vad: VADConfigDraft | null;
  turn_detection_enabled: boolean;
  noise_reduction_enabled: boolean;
}

export interface StrategyRealtimeConfigDraft {
  realtime: RealtimeConfigDraft | null;
}

export interface STTLLMTTSStrategyConfigDraft extends StrategyRealtimeConfigDraft {
  stt: ProviderSettingsDraft | null;
  llm: ProviderSettingsDraft | null;
  tts: ProviderSettingsDraft | null;
  user_idle_timeout: number;
}

export interface LLMTTSStrategyConfigDraft extends StrategyRealtimeConfigDraft {
  llm: ProviderSettingsDraft | null;
  tts: ProviderSettingsDraft | null;
}

export interface Voice2VoiceStrategyConfigDraft extends StrategyRealtimeConfigDraft {
  model: string;
  temperature?: number;
  voice_config?: Record<string, any> | null;
}

export type StrategyConfigDraft =
  | STTLLMTTSStrategyConfigDraft
  | LLMTTSStrategyConfigDraft
  | Voice2VoiceStrategyConfigDraft
  | null;

export const DEFAULT_VAD_CONFIG: VADConfigDraft = {
  enabled: true,
  confidence: 0.7,
  start_secs: 0.2,
  stop_secs: 0.8,
  min_volume: 0.6,
};

export const DEFAULT_PROVIDER_SETTINGS: ProviderSettingsDraft = {
  provider: null,
  settings: {},
};

export const DEFAULT_REALTIME_CONFIG: RealtimeConfigDraft = {
  vad: { ...DEFAULT_VAD_CONFIG },
  turn_detection_enabled: true,
  noise_reduction_enabled: false,
};

export const DEFAULT_STT_LLM_TTS_CONFIG: STTLLMTTSStrategyConfigDraft = {
  realtime: { ...DEFAULT_REALTIME_CONFIG },
  stt: null,
  llm: null,
  tts: null,
  user_idle_timeout: 20,
};

export const DEFAULT_LLM_TTS_CONFIG: LLMTTSStrategyConfigDraft = {
  realtime: { ...DEFAULT_REALTIME_CONFIG },
  llm: null,
  tts: null,
};

export const DEFAULT_VOICE2VOICE_CONFIG: Voice2VoiceStrategyConfigDraft = {
  realtime: { ...DEFAULT_REALTIME_CONFIG },
  model: "gemini-live-2.5-flash",
  temperature: 0.7,
  voice_config: null,
};

export const cloneStrategyConfig = <T>(config: T): T =>
  JSON.parse(JSON.stringify(config));

export const emptyProviderSettings = (): ProviderSettingsDraft => ({
  provider: null,
  settings: {},
});

export const defaultProvidersState = (): StrategyProviders => ({
  v2v: null,
  llm: null,
  tts: null,
  stt: null,
});
